import { render, staticRenderFns } from "./userMsg.vue?vue&type=template&id=948d1bda&scoped=true"
import script from "./userMsg.vue?vue&type=script&lang=js"
export * from "./userMsg.vue?vue&type=script&lang=js"
import style0 from "./userMsg.vue?vue&type=style&index=0&id=948d1bda&prod&lang=scss"
import style1 from "./userMsg.vue?vue&type=style&index=1&id=948d1bda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948d1bda",
  null
  
)

export default component.exports